"use client";
import { STORAGE_SESSION_ID_KEY } from "@/lib/constants";
import { initializeSessionId } from "@/lib/utils/user-session-id";
import { useEffect } from "react";

export default function Session() {
	useEffect(() => {
		initializeSessionId({
			storageSessionIdKey: STORAGE_SESSION_ID_KEY,
			uuid: true,
		});
	}, []);
	return null;
}
